<template>
  <div
    class="call-office d-flex"
    :class="classes"
  >
    <img
      v-if="this.$ppUi.isMobile"
      class="ml-1 mr-10"
      src="@/assets/call-office-mobile.png"
      alt="Call office"
    >
    <img
      v-else
      src="@/assets/call-office.png"
      alt="Call office"
    >
    <div>
      Please call our office
      <template v-if="phoneNumber">
        at
        <a
          data-cy="phone-link"
          :href="`tel:${phoneNumber}`"
        >{{ phoneToShow }}</a>
      </template>
      to schedule {{ phoneNumber ? 'your' : 'an' }} appointment{{ nameText }}
    </div>
  </div>
</template>
<script>
/*
  component supports 4 messages types
  1. Please call our office at (555) 555-5555 to schedule your appointment with Dr. Smith. - phone exist, name can be shown exist
  2. Please call our office to schedule an appointment with Dr. Smith. - no phone, name can be shown
  3. Please call our office at (555) 555-5555 to schedule your appointment. - phone exist, name can't be shown
  4. Please call our office to schedule an appointment - no phone, name can't be shown
 */
import { CALENDAR_TYPES } from '@/views/constants'

export default {
  name: 'CallOffice',
  props: {
    apptPhone: {
      type: String,
      default: ''
    },
    apptFormattedPhone: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    phoneNumber () {
      return this.apptPhone || this.phoneToShow
    },
    phoneToShow () {
      return this.apptFormattedPhone || this.apptPhone
    },
    nameText () {
      return this.showName ? ` with ${this.name}.` : '.'
    },
    showName () {
      return (this.type === CALENDAR_TYPES.PROVIDER_LOCATION_TYPE || this.type === CALENDAR_TYPES.PROVIDER_TYPE) && this.name
    },
    classes () {
      return this.$ppUi.isMobile ? 'flex-row rounded align-center justify-center pa-3' : 'flex-column align-center text-center rounded py-4 px-8'
    }
  }
}
</script>
<style lang="scss" scoped>
.call-office {
  background: $grey-10;
  flex-basis: 325px;
}
</style>
